export default __webpack_public_path__ + "static/work-1-a12660f5e574ae816a397bdf01550c87.jpg";